<h1 mat-dialog-title>
    <span translate>admin.parametres.personnalisation.boiteLien.title</span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<form #form="ngForm">
    <div mat-dialog-content>
        <fieldset *ngIf="boiteLien != null">
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="libelle"
                        name="libelle"
                        customType="input"
                        [(ngModel)]="boiteLien.libelle"
                        lCol="2" rCol="6"
                        libelle="admin.parametres.personnalisation.boiteLien.libelle"
                        [required]="true"
                        [maxlength]="1000"
                ></custom-input>
                <custom-input
                        ngDefaultControl
                        id="actif"
                        name="actif"
                        customType="checkbox"
                        [ngModel]="boiteLien.actif"
                        [(customModel)]="boiteLien.actif"
                        lCol="2" rCol="2"
                        libelle="admin.parametres.personnalisation.boiteLien.actif"
                ></custom-input>
            </div>
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="url"
                        name="url"
                        customType="input"
                        [(ngModel)]="boiteLien.url"
                        lCol="2" rCol="6"
                        libelle="admin.parametres.personnalisation.boiteLien.url"
                        [required]="true"
                        [maxlength]="2000"
                        pattern="https?://.+"
						#urlInput="ngModel"
                ></custom-input>
                <custom-input
                        ngDefaultControl
                        id="ordre"
                        name="ordre"
                        customType="number"
                        [(ngModel)]="boiteLien.ordre"
                        lCol="2" rCol="1"
                        libelle="admin.parametres.personnalisation.boiteLien.ordre"
                        [required]="true"
                        [min]="0"
                        [max]="9"
                ></custom-input>
            </div>
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="infobulle"
                        name="infobulle"
                        customType="textarea"
                        [(ngModel)]="boiteLien.remarque"
                        lCol="2" rCol="9"
                        libelle="admin.parametres.personnalisation.boiteLien.infobulle"
                        [maxlength]="2000"
                ></custom-input>
            </div>
        </fieldset>
        <please-wait *ngIf="boiteLien == null"></please-wait>
    </div>
    <div mat-dialog-actions align="end">
        <button *ngIf="boiteLien.idLien != null" mat-stroked-button color="warn" (click)="delete()">
            <span *ngIf="!isSaving" translate>global.actions.supprimer</span>
            <mat-spinner class="m-5" diameter="28" *ngIf="isSaving"></mat-spinner>
        </button>
        <button mat-flat-button color="primary" type="submit" (click)="save()" [disabled]="form.invalid">
            <span *ngIf="!isSaving" translate>global.actions.enregistrer</span>
            <mat-spinner class="m-5" diameter="28" *ngIf="isSaving"></mat-spinner>
        </button>
    </div>
</form>
